import React from 'react';
import { motion } from 'framer-motion';
import { 
  CalendarIcon,
  ChartBarIcon,
  ArrowTrendingUpIcon,
  ClockIcon,
  ArrowPathIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

const ForecastingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center mb-4">
              <CalendarIcon className="h-8 w-8 text-purple-600 mr-3" />
              <h1 className="text-3xl font-bold text-gray-900">Forecasting</h1>
            </div>
            <p className="text-lg text-gray-600">
              AI-powered trend predictions to help you stay ahead of the curve.
            </p>
          </motion.div>
        </div>

        {/* Coming Soon Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center"
        >
          <div className="max-w-md mx-auto">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CalendarIcon className="h-8 w-8 text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon</h2>
            <p className="text-gray-600 mb-6">
              We're building advanced forecasting capabilities to predict future trends and help you make data-driven decisions.
            </p>
            <div className="space-y-4 text-left">
              <div className="flex items-center text-gray-700">
                <ArrowTrendingUpIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>14-day trend predictions</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ChartBarIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Growth trajectory analysis</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ClockIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Peak timing predictions</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ArrowPathIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Seasonal pattern recognition</span>
              </div>
              <div className="flex items-center text-gray-700">
                <SparklesIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Confidence scoring</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ForecastingPage;
